import { types } from 'mobx-state-tree';
import { createThunk, ListModel, model } from 'mst-collection';

import { Api, schemas } from '@api';
import { UserModel } from './UserModel';

export class SuggestedUserList extends ListModel(
  types.reference(UserModel),
  {
    idAttribute: 'id',
    schema: schemas.UserListSchema,
  },
) {
  fetch = createThunk(() => {
    return async function fetch(this: SuggestedUserList) {
      const res = await Api.Profile.getSuggestedUsers();

      this.set(res.data);
    };
  });
}

export const SuggestedUserListModel = model(SuggestedUserList);
